/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type WorkUnitsTrendBucket = {
  /**
   * Cost per unit of work. Absent when the bucket has no positive work or no cost telemetry.
   */
  costPerUnit?: number | undefined;
  /**
   * Number of chat sessions scored by the work-units analysis in this bucket.
   */
  scoredSessions: number;
  /**
   * Start of the UTC day this bucket covers.
   */
  timestamp: Date;
  /**
   * Tokens per unit of work. Absent when the bucket has no positive work or no token telemetry.
   */
  tokensPerUnit?: number | undefined;
  /**
   * Total cost in USD across the bucket's scored sessions.
   */
  totalCost: number;
  /**
   * Total tokens across the bucket's scored sessions.
   */
  totalTokens: number;
  /**
   * Total work units delivered across the bucket's scored sessions.
   */
  workUnits: number;
};

/** @internal */
export const WorkUnitsTrendBucket$inboundSchema: z.ZodMiniType<
  WorkUnitsTrendBucket,
  unknown
> = z.pipe(
  z.object({
    cost_per_unit: z.optional(z.number()),
    scored_sessions: z.int(),
    timestamp: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    tokens_per_unit: z.optional(z.number()),
    total_cost: z.number(),
    total_tokens: z.int(),
    work_units: z.number(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "cost_per_unit": "costPerUnit",
      "scored_sessions": "scoredSessions",
      "tokens_per_unit": "tokensPerUnit",
      "total_cost": "totalCost",
      "total_tokens": "totalTokens",
      "work_units": "workUnits",
    });
  }),
);

export function workUnitsTrendBucketFromJSON(
  jsonString: string,
): SafeParseResult<WorkUnitsTrendBucket, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkUnitsTrendBucket$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkUnitsTrendBucket' from JSON`,
  );
}
